import { __assign } from "tslib";
import { createClient } from '@wix/sdk/client';
import * as cart from '@wix/auto_sdk_ecom_cart-v-2';
import { getSDKAuthAndHost } from '../getSDKAuthAndHost';
var CartService = /** @class */ (function () {
    function CartService(siteStore) {
        this.cartApi = createClient(__assign(__assign({}, getSDKAuthAndHost(siteStore)), { modules: {
                cart: {
                    getCart: cart.getCart,
                    calculateCart: cart.calculateCart,
                    updateCart: cart.updateCart,
                    removeGiftCard: cart.removeGiftCard,
                    addGiftCard: cart.addGiftCard,
                    addCoupon: cart.addCoupon,
                    removeCoupon: cart.removeCoupon,
                    removeLineItems: cart.removeLineItems,
                    setDeliveryMethod: cart.setDeliveryMethod,
                    refreshCart: cart.refreshCart,
                    placeOrder: cart.placeOrder,
                },
            } })).cart;
    }
    CartService.prototype.getCart = function (cartId) {
        return this.cartApi.getCart(cartId);
    };
    CartService.prototype.calculateCart = function (cartId) {
        return this.cartApi.calculateCart(cartId);
    };
    CartService.prototype.updateCart = function (cartId, updateCart) {
        return this.cartApi.updateCart(cartId, updateCart);
    };
    CartService.prototype.removeGiftCard = function (cartId, giftCardId) {
        return this.cartApi.removeGiftCard(cartId, giftCardId);
    };
    CartService.prototype.addGiftCard = function (cartId, giftCardInput) {
        return this.cartApi.addGiftCard(cartId, giftCardInput);
    };
    CartService.prototype.removeCoupon = function (cartId, couponId) {
        return this.cartApi.removeCoupon(cartId, couponId);
    };
    CartService.prototype.addCoupon = function (cartId, couponInput) {
        return this.cartApi.addCoupon(cartId, couponInput);
    };
    CartService.prototype.removeLineItems = function (cartId, lineItemIds) {
        return this.cartApi.removeLineItems(cartId, lineItemIds);
    };
    CartService.prototype.setDeliveryMethod = function (cartId, deliveryMethod) {
        return this.cartApi.setDeliveryMethod(cartId, deliveryMethod);
    };
    CartService.prototype.refreshCart = function (cartId) {
        return this.cartApi.refreshCart(cartId);
    };
    CartService.prototype.placeOrder = function (cartId, placeOrderOptions) {
        return this.cartApi.placeOrder(cartId, placeOrderOptions);
    };
    return CartService;
}());
export { CartService };
//# sourceMappingURL=CartService.js.map